import { render, staticRenderFns } from "./AuthVerify.vue?vue&type=template&id=6065d152&scoped=true&lang=pug&"
import script from "./AuthVerify.vue?vue&type=script&lang=js&"
export * from "./AuthVerify.vue?vue&type=script&lang=js&"
import style0 from "./AuthVerify.vue?vue&type=style&index=0&id=6065d152&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6065d152",
  null
  
)

export default component.exports